/**
 * Not Found Page (404)
 * Shown for unknown routes instead of a silent redirect.
 */

import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

export const NotFoundPage = () => {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-dark-bg-primary px-6">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/30">
          <Compass className="h-7 w-7 text-blue-500 dark:text-blue-400" />
        </div>
        <p className="text-4xl font-bold text-gray-900 dark:text-dark-text-primary">404</p>
        <h1 className="mt-2 text-lg font-semibold text-gray-900 dark:text-dark-text-primary">
          Страницата не е намерена
        </h1>
        <p className="mt-2 text-sm text-gray-500 dark:text-dark-text-muted">
          Страницата, която търсите, не съществува или е преместена.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center justify-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Към началото
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
